
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkTenantProjectLinkSyncSettingsDto } from '../models/work-tenant-project-link-sync-settings-dto';

export function getUpdateTenantDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.maxLength(255)]),
    description: new FormControl<string | undefined>(''),
    baseUrl: new FormControl<string | undefined>('', [Validators.maxLength(500)]),
    apiKey: new FormControl<string | undefined>('', [Validators.maxLength(500)]),
    active: new FormControl<boolean | undefined>(true),
    contactId: new FormControl<number | undefined>(undefined),
    notificationEmails: new FormControl<string | undefined>('', [Validators.maxLength(1000)]),
    syncSettings: new FormControl<WorkTenantProjectLinkSyncSettingsDto | undefined>(undefined),
})
;
}
      